import React, { Component } from 'react';
import {getIdByticketLI,getQueryVariable} from "../../requist";
import SAPCustomer from '../../data/menu/SAPCustomer.json';
import {message, Spin} from 'antd';
class SAPLogin extends Component{

    componentDidMount() {
        window.localStorage.removeItem('userToken');
        window.localStorage.removeItem('lenovoid');
        window.localStorage.removeItem('sst');
        window.localStorage.removeItem('userInfo');
        window.localStorage.removeItem('menuList');
        let ticket = getQueryVariable('ticket')
        if(ticket){
            window.localStorage.setItem('menuList',JSON.stringify(SAPCustomer));
            getIdByticketLI(ticket).then(res=>{
                console.info(res)
                if(res.result){
                    window.localStorage.removeItem('userId');
                    window.localStorage.removeItem('userToken');
                    window.localStorage.removeItem('lenovoid');
                    window.localStorage.removeItem('sst');
                    window.localStorage.setItem('userToken',res.data.userToken);
                    window.localStorage.setItem('userId', res.data.requestorID);
                    window.localStorage.removeItem('userInfo');
                    window.localStorage.setItem('userInfo',JSON.stringify(res.data));
                }else{
                    window.localStorage.removeItem('userId');
                    window.localStorage.removeItem('userToken');
                    window.localStorage.removeItem('lenovoid');
                    window.localStorage.removeItem('sst');
                    message.error(`${res.msg}`)
                }
            }).finally(()=>{
                window.location.href='/disputeHome'
            })
        } else {
            message.warn('Auth failed, please relogin', 1.5)
            .then(()=>{
                window.location.href = '/disputeHome'
            })
            
        }
    }
    render() {
        return  <div className="loginSpin">
        <Spin />
      </div>;
    }
}

export default SAPLogin;